<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn  btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
          </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "business/parts",
    cardSetLink: "business/parts",
    item: null,
    fields: [
       {
          label: "Четверть",
          key: "position",
          type: "static_radio",
          items: [
            { id: '1', title: "I четверть" },
            { id: '2', title: "II четверть" },
            { id: '3', title: "III четверть" },
            { id: '4', title: "IV четверть" },
          ],
      },
        {
          col:'col-12 col-md-6',
          key: "from_at",
          label: "Начало четверти",
          type: "field",
          textType: "date",
          readonly: false,
          dateFormat: true,
      },
      {
       col:'col-12 col-md-6',
        key: "till_at",
        label: "Окончание четверти",
        type: "field",
          textType: "date",
        readonly: false,
        dateFormat: true,
      },
      ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
